var map = {
	"./Group52.png": 8119,
	"./Group52_1.png": 1600,
	"./Group53.png": 9942,
	"./Group53_1.png": 5545,
	"./Group54.png": 4333,
	"./Group54_1.png": 3588,
	"./Group55.png": 2733,
	"./Group55_1.png": 2847,
	"./Group56.png": 7644,
	"./Group56_1.png": 2519,
	"./icon_1.png": 7885,
	"./icon_10.png": 4417,
	"./icon_11.png": 9405,
	"./icon_12.png": 8426,
	"./icon_13.png": 1607,
	"./icon_14.png": 4942,
	"./icon_15.png": 3003,
	"./icon_16.png": 2993,
	"./icon_17.png": 7864,
	"./icon_2.png": 1436,
	"./icon_3.png": 7017,
	"./icon_4.png": 4690,
	"./icon_5.png": 953,
	"./icon_6.png": 1606,
	"./icon_7.png": 8309,
	"./icon_8.png": 9623,
	"./icon_9.png": 260,
	"./一键.png": 2114,
	"./云游戏.png": 4612,
	"./传感器.png": 6069,
	"./前景覆层.png": 222,
	"./发行.png": 3220,
	"./启动.png": 6279,
	"./平台.png": 6665,
	"./微端.png": 5777,
	"./控制权.png": 4143,
	"./支付.png": 3988,
	"./文件.png": 2121,
	"./更新.png": 748,
	"./游戏.png": 2328,
	"./画质.png": 8448,
	"./直播.png": 5934,
	"./背景装饰.png": 6747,
	"./适配.png": 3815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8722;